import React from "react";
import { P } from "../../designSystem/typography/Body";
import { clientAccessHelper } from "../../utils/clientAccessHelper";
import { ProtectedPageContext } from "../_contexts/ProtectedPageContext";
import { MemberPageWrapper } from "../_pageWrappers/MemberPageWrapper";
import { SupportListingView } from "./_components/SupportListingView";

export function SupportPage(): JSX.Element  {

    return (
        <MemberPageWrapper breadCrumbs={[{ text: 'Support', url: '' }]}>
            <SupportPageContent />
        </MemberPageWrapper>
    );
}

function SupportPageContent(): JSX.Element {
    const activeUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['ViewActivity']);

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return <SupportListingView />;
}